import { StudentsNoAppUsage } from 'presentation/app/modules/Reports/pages/students/students-no-app-usage';
import React from 'react';

export const MakeStudentsNoAppUsage: React.FC = () => {
  return <StudentsNoAppUsage />;
};
